export default __webpack_public_path__ + "media/images/home/testimonials-bg-d5b2e5ff8667c2c73247ac057e1fa1ff.svg";